<template>
  <div class="gs-app gm-dashboard-chart-stat w-full flex">
    <div class="w-full flex flex-row">
      <div class="flex flex-col w-full justify-end content-end">
        <p
          v-if="chartStat && chartStat.hasLoaded" 
          class="block text-deep-dark mb-1 pl-6 gm-dashboard-chart-stat__value">
          {{ chartStat.value || 0 }}
        </p>
        <div class="h-1/3 w-1/3 pl-2" v-else>
          <countContentLoader />
        </div>
        <span class="block text-sm text-grey-700 pl-6">
          {{ chartStat.title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import countContentLoader from '@/components/content-loader/countcontentloader';

export default {
  name: 'DahboardChartStat',

  props: {
    chartStat: {
      required: true,
    },
  },

  components: {
    countContentLoader
  }
};
</script>

<style scoped>
.gm-dashboard-chart-stat__value {
  color: var(--gs-foreground);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
}
</style>
